<script setup lang="ts">
import { defineProps, computed } from 'vue'
import AUserDisplayModeSwitch from '@/components/molecules/AUserDisplayModeSwitch/index.vue'
import LangSwitch from '@/components/molecules/LangSwitch.vue'
import ANotification from '@/components/organisms/ANotification/index.vue'
import type { SideMenuDisplayMode } from '@/constants/enums/SideMenuDisplayMode'
import { useAuthStore } from '@/stores/authStore'
import { isUserDisplayMode } from '@/constants/enums/UserDisplayMode'

type Props = {
  isGuest: boolean
  sideMenuDisplayMode: SideMenuDisplayMode
}
const props = defineProps<Props>()

const authStore = useAuthStore()

const userDisplayMode = computed(() => authStore.userDisplayMode)
</script>

<template>
  <div class="a-header-navigation">
    <AUserDisplayModeSwitch
      v-if="!props.isGuest"
    />
    <ANotification
      v-if="isUserDisplayMode(userDisplayMode)"
      :is-guest="props.isGuest"
      :side-menu-display-mode="props.sideMenuDisplayMode"
      :user-display-mode="userDisplayMode"
    />
    <LangSwitch />
  </div>
</template>

<style lang="scss" scoped>
.a-header-navigation {
  display: flex;
  gap: 12px;
  align-items: center;
}
</style>
